// Copyright © 2017 David Caldwell <david@porkrind.org>

var lib = require('./lib'), rot13=lib.rot13;
var dom = require('./dom'), timeout=dom.timeout, px=dom.px, doc=dom.doc, on_load=dom.on_load, Cookie=dom.Cookie;
var Login = require('./login');
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var prnt = require('./print'), printf=prnt.printf;
var alert = require('./alert'), new_text_alert=alert.new_text_alert;

var div = doc.id("account_settings");

function update() {
    if (!Login || !Login.is_logged_in()) {
        doc.appendTo(doc.clear(div), doc(['div',
                                       ['p', "To edit your account, you must be logged in."],
                                          ["input", { type:"button", value:"Login", id:"login", onclick:function() { Login.login_dialog(); } }]]));
        doc.id("title").firstChild.textContent = "You are not logged in.";
        return;
    }

    doc.id("title").firstChild.textContent = "Account settings for "+Login.user;
    var new_username, username_error, password, change_username, old_password, new_password, new_password2, old_password_error, new_password_error, new_password2_error, change_password, submit_username, submit_password;
    doc.appendTo(doc.clear(div), doc(
        ['div',
         ['h2', "Username"],
         ['form', _=>change_username=_,
          ['table',
           ['tbody',
            ['tr',
             ['td',
              ['label', {'for':"password"}, "Password"]],
             ['td',
              ['input', {type:"password", id:"password", name:"password"}, _=>password=_]]],
            ['tr',
             ['td', ['label', {'for':'new_username' }, 'New Username:']],
             ['td',
              ['input', { type: "text", value: Login.user, id:"new_username", name:"new_username" }, _=>new_username=_ ],
              ['span', { className: "error" }, _=>username_error=_ ]]],
            ['tr',
             ['td', { colSpan: 2 },
              ['input', { type: "submit", name:"submit", value: "Change Username", disabled: true, style: { display: "block" } }, _=>submit_username=_ ]]]]]],
         ['h2', "Password"],
         ['form', _=>change_password=_,
          ['table',
           ['tbody',
            ['tr', { hidden: true },
             ['td',
              ['label', {'for':"current_username"}, 'Current Username']],
             ['td',
              ['input', { type:'text', id:"current_username", name:"current_username",
                          autocapitalize: "off", autocorrect: false, value: Login.user }]]],
            ['tr',
             ['td',
              ['label', {'for':'old_password' }, 'Old Password:']],
             ['td',
              ['input', { type:'password' }, _=>old_password=_],
              ['span', { className: "error" }, _=>old_password_error=_ ]]],
            ['tr',
             ['td', ['label', {'for':'new_password' }, 'New Password:']],
             ['td',
              ['input', { type:'password', id:"new_password", name:"new_password" }, _=>new_password=_ ],
              ['span', { className: "error" }, _=>new_password_error=_]]],
            ['tr',
             ['td',
              ['label', {'for':'new_password2' }, 'Verify Password:']],
             ['td',
              ['input', { type:'password', id:"new_password2", name:"new_password2" }, _=>new_password2=_ ],
              ['span', { className: "error" }, _=>new_password2_error=_]]],
            ['tr',
             ['td', { colSpan: 2 },
              ['input', { type: "submit", name:"submit", value: "Change Password", disabled: true}, _=>submit_password=_ ]]]]]]]
    ));

    change_username.onsubmit = function(ev) {
        submit_username.disabled = true;
        postJSON(makeurl('user', 'change', 'username', { old_user: Login.user, new_user: new_username.value, password: rot13(password.value) }), {}, function(data, error, status) {
            if (error)
                return update_username_error(error);
            Login.update_cookies();
            new_text_alert("You are now known as "+new_username.value+"!", {title:"Username Changed"});
            update();
        });
        ev.preventDefault();
    };

    change_password.onsubmit = function(ev) {
        submit_password.disabled = true;
        postJSON(makeurl('user', 'change', 'password', { old_pass: rot13(old_password.value),
                                                         new_pass: rot13(new_password.value),
                                                         user: Login.user }), {}, function(data, error, status) {
            if (error)
                return update_error(old_password_error, submit_password, error);
            new_text_alert("Your password has been updated!", {title:"Password Changed"});
            update();
        });
        ev.preventDefault();
    };

    var update_error = function(error_div, button, error) {
        button.disabled = !!error;
        if (error == "dont_report") return doc.clear(error_div);
        doc.appendTo(doc.clear(error_div),
                     doc(['span', { className: error ? "error" : "ok" }, error || '' ]));
    };

    var update_username_error = function(error) {
        update_error(username_error, submit_username, error);
    };

    var validate_username = function(new_name, password) {
        if (new_name == Login.user) return update_username_error("dont_report");
        loadJSON(makeurl('user', 'change', 'username', { old_user: Login.user, new_user: new_name, password: rot13(password) }), function(data, error, status) {
            update_username_error(error);
        });
    };

    password.onchange =
    new_username.oninput = function() {
        validate_username(new_username.value, password.value);
    };

    var validate_passwords = function() {
        update_error(new_password_error,  submit_password, new_password.value  == "" ? "dont_report" : new_password.value == old_password.value && "The new password should be different than the old password.");
        update_error(new_password2_error, submit_password, new_password2.value == "" ? "dont_report" : new_password.value != new_password2.value && "Doesn't match New Password.");
    };

    new_password.onchange = new_password2.onchange = validate_passwords;
    old_password.onchange = function() {
        validate_passwords();
        update_error(old_password_error, submit_password, undefined);
    }
}

on_load(update);
Login.on_login(update);
// Copyright © 2017 David Caldwell <david@porkrind.org>

var lib = require('./lib'), rot13=lib.rot13;
var dom = require('./dom'), timeout=dom.timeout, px=dom.px, doc=dom.doc, on_load=dom.on_load, Cookie=dom.Cookie;
var Login = require('./login');
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var prnt = require('./print'), printf=prnt.printf;
var alert = require('./alert'), new_text_alert=alert.new_text_alert;

var div = doc.id("account_settings");

function update() {
    if (!Login || !Login.is_logged_in()) {
        doc.appendTo(doc.clear(div), doc(['div',
                                       ['p', "To edit your account, you must be logged in."],
                                          ["input", { type:"button", value:"Login", id:"login", onclick:function() { Login.login_dialog(); } }]]));
        doc.id("title").firstChild.textContent = "You are not logged in.";
        return;
    }

    doc.id("title").firstChild.textContent = "Account settings for "+Login.user;
    var new_username, username_error, password, change_username, old_password, new_password, new_password2, old_password_error, new_password_error, new_password2_error, change_password, submit_username, submit_password;
    doc.appendTo(doc.clear(div), doc(
        ['div',
         ['h2', "Username"],
         ['form', _=>change_username=_,
          ['table',
           ['tbody',
            ['tr',
             ['td',
              ['label', {'for':"password"}, "Password"]],
             ['td',
              ['input', {type:"password", id:"password", name:"password"}, _=>password=_]]],
            ['tr',
             ['td', ['label', {'for':'new_username' }, 'New Username:']],
             ['td',
              ['input', { type: "text", value: Login.user, id:"new_username", name:"new_username" }, _=>new_username=_ ],
              ['span', { className: "error" }, _=>username_error=_ ]]],
            ['tr',
             ['td', { colSpan: 2 },
              ['input', { type: "submit", name:"submit", value: "Change Username", disabled: true, style: { display: "block" } }, _=>submit_username=_ ]]]]]],
         ['h2', "Password"],
         ['form', _=>change_password=_,
          ['table',
           ['tbody',
            ['tr', { hidden: true },
             ['td',
              ['label', {'for':"current_username"}, 'Current Username']],
             ['td',
              ['input', { type:'text', id:"current_username", name:"current_username",
                          autocapitalize: "off", autocorrect: false, value: Login.user }]]],
            ['tr',
             ['td',
              ['label', {'for':'old_password' }, 'Old Password:']],
             ['td',
              ['input', { type:'password' }, _=>old_password=_],
              ['span', { className: "error" }, _=>old_password_error=_ ]]],
            ['tr',
             ['td', ['label', {'for':'new_password' }, 'New Password:']],
             ['td',
              ['input', { type:'password', id:"new_password", name:"new_password" }, _=>new_password=_ ],
              ['span', { className: "error" }, _=>new_password_error=_]]],
            ['tr',
             ['td',
              ['label', {'for':'new_password2' }, 'Verify Password:']],
             ['td',
              ['input', { type:'password', id:"new_password2", name:"new_password2" }, _=>new_password2=_ ],
              ['span', { className: "error" }, _=>new_password2_error=_]]],
            ['tr',
             ['td', { colSpan: 2 },
              ['input', { type: "submit", name:"submit", value: "Change Password", disabled: true}, _=>submit_password=_ ]]]]]]]
    ));

    change_username.onsubmit = function(ev) {
        submit_username.disabled = true;
        postJSON(makeurl('user', 'change', 'username', { old_user: Login.user, new_user: new_username.value, password: rot13(password.value) }), {}, function(data, error, status) {
            if (error)
                return update_username_error(error);
            Login.update_cookies();
            new_text_alert("You are now known as "+new_username.value+"!", {title:"Username Changed"});
            update();
        });
        ev.preventDefault();
    };

    change_password.onsubmit = function(ev) {
        submit_password.disabled = true;
        postJSON(makeurl('user', 'change', 'password', { old_pass: rot13(old_password.value),
                                                         new_pass: rot13(new_password.value),
                                                         user: Login.user }), {}, function(data, error, status) {
            if (error)
                return update_error(old_password_error, submit_password, error);
            new_text_alert("Your password has been updated!", {title:"Password Changed"});
            update();
        });
        ev.preventDefault();
    };

    var update_error = function(error_div, button, error) {
        button.disabled = !!error;
        if (error == "dont_report") return doc.clear(error_div);
        doc.appendTo(doc.clear(error_div),
                     doc(['span', { className: error ? "error" : "ok" }, error || '' ]));
    };

    var update_username_error = function(error) {
        update_error(username_error, submit_username, error);
    };

    var validate_username = function(new_name, password) {
        if (new_name == Login.user) return update_username_error("dont_report");
        loadJSON(makeurl('user', 'change', 'username', { old_user: Login.user, new_user: new_name, password: rot13(password) }), function(data, error, status) {
            update_username_error(error);
        });
    };

    password.onchange =
    new_username.oninput = function() {
        validate_username(new_username.value, password.value);
    };

    var validate_passwords = function() {
        update_error(new_password_error,  submit_password, new_password.value  == "" ? "dont_report" : new_password.value == old_password.value && "The new password should be different than the old password.");
        update_error(new_password2_error, submit_password, new_password2.value == "" ? "dont_report" : new_password.value != new_password2.value && "Doesn't match New Password.");
    };

    new_password.onchange = new_password2.onchange = validate_passwords;
    old_password.onchange = function() {
        validate_passwords();
        update_error(old_password_error, submit_password, undefined);
    }
}

on_load(update);
Login.on_login(update);
